// third-party
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import PhoneIcon from '@mui/icons-material/Phone';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import SchoolIcon from '@mui/icons-material/School';
import TextsmsIcon from '@mui/icons-material/Textsms';
import StarIcon from '@mui/icons-material/Star';
import EmailIcon from '@mui/icons-material/Email';
import ReportIcon from '@mui/icons-material/Report';
import BarChartIcon from '@mui/icons-material/BarChart'; // General Statistic için ikon
import PieChartIcon from '@mui/icons-material/PieChart';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import GridOnIcon from "@mui/icons-material/GridOn";

import SearchIcon from '@mui/icons-material/Search';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import TextField from '@mui/material/TextField';
import { useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { ListItem } from '@mui/material';
import { useState, useEffect } from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
// ==============================|| Sidebar Items ||============================== //

const CustomSearchItem = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchValue, setSearchValue] = useState('');

    // Reset search value when route changes
    useEffect(() => {
        setSearchValue('');
    }, [location.pathname]);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            navigate(`/search-page?search=${encodeURIComponent(searchValue)}`);
        }
    };

    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    return (
        <ListItem
            sx={{
                p: 1,
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }}
        >
            <TextField
                size="small"
                fullWidth
                value={searchValue}
                onChange={handleChange}
                placeholder="Search and press Enter"
                onKeyPress={handleKeyPress}
                InputProps={{
                    startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} />,
                    sx: {
                        cursor: 'text',
                        backgroundColor: 'background.paper',
                        '&:hover': {
                            backgroundColor: 'action.hover'
                        }
                    }
                }}
            />
        </ListItem>
    );
};

const getSidebarItems = (role) => {

    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const check_specialist = userData?.is_specialist || userData?.standard_consulling > 0;
    const showCoupons = !check_specialist && (userData?.coupon_count > 0);
    const showPeerSharedCases = (userData?.peer_shared_cases_count || 0) > 0;
    const showPeerShareRequests = (userData?.peer_share_requests_inbox_count ?? userData?.peer_share_requests_pending_count ?? 0) > 0;
    const countryIsTr = userData?.country === "0";
    const accountPaymentsAllowedIds = [6641, 2037, 19355, 4084, 2406, 14865, 2721, 7];
    const showAccountPayments = countryIsTr && accountPaymentsAllowedIds.includes(Number(userData?.id));

    const roleBasedItems = {
        doctor: [
            {
                id: 'main-panel',
                title: <FormattedMessage id="Main panel" />,
                type: 'item',
                url: '/main-panel',
                icon: LocationOnIcon,
                breadcrumbs: false
            },
            {
                id: 'patients',
                title: <FormattedMessage id="Patients" />,
                type: 'item',
                url: '/patients',
                icon: GroupIcon,
                breadcrumbs: false
            },
            {
                id: 'patient-app',
                title: <FormattedMessage id="Patient App" defaultMessage="Patient App" />,
                type: 'item',
                url: '/patient-app',
                icon: PhoneIphoneIcon,
                breadcrumbs: false,
            },
            {
                id: 'profile-settings',
                title: <FormattedMessage id="Edit Profile" />,
                type: 'item',
                url: '/profile-settings',
                icon: PersonIcon,
                breadcrumbs: true
            },
            // {
            //     id: 'calendar',
            //     title: <FormattedMessage id="calendar" />,
            //     type: 'item',
            //     url: '/calendar',
            //     icon: DateRangeIcon,
            //     breadcrumbs: true
            // },
            {
                id: 'gallery',
                title: <FormattedMessage id="Gallery" />,
                type: 'item',
                url: '/gallery',
                icon: CollectionsBookmarkIcon,
                breadcrumbs: true
            },
            {
                id: 'promotions',
                title: <FormattedMessage id="Promotions" />,
                type: 'item',
                url: '/promotions',
                icon: ReceiptLongIcon,
                breadcrumbs: true
            },
            // {
            //     id: 'store',
            //     title: <FormattedMessage id="Store" />,
            //     type: 'item',
            //     url: '/store',
            //     icon: LocalGroceryStoreIcon,
            //     breadcrumbs: true
            // },
            {
                id: 'academy',
                title: <FormattedMessage id="Academy" />,
                type: 'item',
                url: '/academy',
                icon: SchoolIcon,
                breadcrumbs: true
            }
            ,
            {
                id: 'clinical',
                title: <FormattedMessage id="Clinical Preferences" />,
                type: 'item',
                url: '/clinical',
                icon: LocalHospitalIcon,
                breadcrumbs: true
            },
            {
                id: 'appointments',
                title: <FormattedMessage id="calendar" />,
                type: 'item',
                url: '/appointments',
                icon: DateRangeIcon,
                breadcrumbs: true
            },
            {
                id: 'notifications',
                title: <FormattedMessage id="Notifications" />,
                type: 'item',
                url: '/notifications',
                icon: TextsmsIcon,
                breadcrumbs: true
            },
            {
                id: 'messages',
                title: <FormattedMessage id="My Messages" />,
                type: 'item',
                url: '/messages',
                icon: EmailIcon,
                breadcrumbs: true
            },
            {
                id: 'orthero-chat',
                title: <FormattedMessage id="Orthero Chat" defaultMessage="Orthero Chat" />,
                type: 'item',
                url: '/orthero-chat',
                icon: ChatOutlinedIcon,
                breadcrumbs: true
            },
            {
                id: 'patientrequest',
                title: <FormattedMessage id="Patient Request" />,
                type: 'item',
                url: '/patient-request',
                icon: AssignmentIcon,
                breadcrumbs: true
            },
            ...(showPeerShareRequests
                ? [
                    {
                        id: 'peersharerequests',
                        title: <FormattedMessage id="Vaka Paylaşım Talepleri" defaultMessage="Vaka Paylaşım Talepleri" />,
                        type: 'item',
                        url: '/peer-share-requests',
                        icon: ForwardToInboxOutlinedIcon,
                        breadcrumbs: true
                    },
                ]
                : []
            ),
            ...(showPeerSharedCases
                ? [
                    {
                        id: 'sharedcases',
                        title: <FormattedMessage id="Benimle Paylaşılan Vakalar" defaultMessage="Benimle Paylaşılan Vakalar" />,
                        type: 'item',
                        url: '/shared-cases',
                        icon: FolderSharedOutlinedIcon,
                        breadcrumbs: true
                    },
                ]
                : []
            ),
            ...(showCoupons
                ? [
                    {
                        id: 'coupons',
                        title: <FormattedMessage id="My Coupons" defaultMessage="My Coupons" />,
                        type: 'item',
                        url: '/coupons',
                        icon: ConfirmationNumberOutlinedIcon,
                        breadcrumbs: true
                    },
                ]
                : []
            ),
            {
                id: 'contact',
                title: <FormattedMessage id="Contact" />,
                type: 'item',
                url: '/contact',
                icon: PhoneIcon,
                breadcrumbs: true
            },
            ...(showAccountPayments
                ? [
                    {
                        id: 'billing-account',
                        title: <FormattedMessage id="Account & Payments" defaultMessage="Faturalar & Ödemeler" />,
                        type: 'item',
                        url: '/billing-account',
                        icon: AccountBalanceWalletIcon,
                        breadcrumbs: true
                    },
                ]
                : []
            ),
            ...(check_specialist
                ? [
                    {
                        id: 'consultationrequests',
                        title: <FormattedMessage id="Consultation Requests" />,
                        type: 'item',
                        url: '/consultation-requests',
                        icon: LightbulbIcon,
                        breadcrumbs: true
                    },
                    {
                        id: 'consultationcase',
                        title: <FormattedMessage id="Consultation Cases" />,
                        type: 'item',
                        url: '/consultation-case',
                        icon: GroupIcon,
                        breadcrumbs: true
                    },
                    // TPS (is_specialist) hekimleri: aylık onaylanan danışmanlık takibi
                    ...(userData?.is_specialist
                        ? [
                            {
                                id: 'consultantmonthlyreport',
                                title: <FormattedMessage id="Monthly Approved Consultations" defaultMessage="Monthly Approved Consultations" />,
                                type: 'item',
                                url: '/consultant-monthly-report',
                                icon: InsertChartIcon,
                                breadcrumbs: true
                            },
                        ]
                        : []
                    ),
                    ...(countryIsTr
                        ? [
                            {
                                id: 'tpsinbox',
                                title: <FormattedMessage id="TPS Inbox" />,
                                type: 'item',
                                url: '/tps-inbox',
                                icon: LiveHelpOutlinedIcon,
                                breadcrumbs: true
                            },
                        ]
                        : []
                    ),
                ]
                : []
            )
        ],
        admin: [
            {
                id: 'main-panel',
                title: <FormattedMessage id="Main panel" />,
                type: 'item',
                url: '/main-panel',
                icon: LocationOnIcon,
                breadcrumbs: false
            },
            {
                id: 'patients',
                title: <FormattedMessage id="Patients" />,
                type: 'item',
                url: '/patients',
                icon: GroupIcon,
                breadcrumbs: false
            },
            {
                id: 'patient-app',
                title: <FormattedMessage id="Patient App" defaultMessage="Patient App" />,
                type: 'item',
                url: '/patient-app',
                icon: PhoneIphoneIcon,
                breadcrumbs: false,
                chip: {
                    label: 'NEW',
                    size: 'small',
                    color: 'secondary',
                    variant: 'filled',
                    sx: {
                        height: 15,
                        fontSize: '0.55rem',
                        fontWeight: 700,
                        letterSpacing: 0.4,
                        '& .MuiChip-label': { px: 0.75 }
                    }
                }
            },
            {
                id: 'profile-settings',
                title: <FormattedMessage id="Edit Profile" />,
                type: 'item',
                url: '/profile-settings',
                icon: PersonIcon,
                breadcrumbs: true
            },
            // {
            //     id: 'calendar',
            //     title: <FormattedMessage id="calendar" />,
            //     type: 'item',
            //     url: '/calendar',
            //     icon: DateRangeIcon,
            //     breadcrumbs: true
            // },
            {
                id: 'gallery',
                title: <FormattedMessage id="Gallery" />,
                type: 'item',
                url: '/gallery',
                icon: CollectionsBookmarkIcon,
                breadcrumbs: true
            },
            {
                id: 'promotions',
                title: <FormattedMessage id="Promotions" />,
                type: 'item',
                url: '/promotions',
                icon: ReceiptLongIcon,
                breadcrumbs: true
            },
            // {
            //     id: 'store',
            //     title: <FormattedMessage id="Store" />,
            //     type: 'item',
            //     url: '/store',
            //     icon: LocalGroceryStoreIcon,
            //     breadcrumbs: true
            // },
            {
                id: 'academy',
                title: <FormattedMessage id="Academy" />,
                type: 'item',
                url: '/academy',
                icon: SchoolIcon,
                breadcrumbs: true
            }
            ,
            {
                id: 'clinical',
                title: <FormattedMessage id="Clinical Preferences" />,
                type: 'item',
                url: '/clinical',
                icon: LocalHospitalIcon,
                breadcrumbs: true
            },
            {
                id: 'appointments',
                title: <FormattedMessage id="calendar" />,
                type: 'item',
                url: '/appointments',
                icon: DateRangeIcon,
                breadcrumbs: true
            },
            {
                id: 'notifications',
                title: <FormattedMessage id="Notifications" />,
                type: 'item',
                url: '/notifications',
                icon: TextsmsIcon,
                breadcrumbs: true
            },
            {
                id: 'messages',
                title: <FormattedMessage id="My Messages" />,
                type: 'item',
                url: '/messages',
                icon: EmailIcon,
                breadcrumbs: true
            },
            {
                id: 'patientrequest',
                title: <FormattedMessage id="Patient Request" />,
                type: 'item',
                url: '/patient-request',
                icon: AssignmentIcon,
                breadcrumbs: true
            },
            ...(showCoupons
                ? [
                    {
                        id: 'coupons',
                        title: <FormattedMessage id="My Coupons" defaultMessage="My Coupons" />,
                        type: 'item',
                        url: '/coupons',
                        icon: ConfirmationNumberOutlinedIcon,
                        breadcrumbs: true
                    },
                ]
                : []
            ),
            {
                id: 'contact',
                title: <FormattedMessage id="Contact" />,
                type: 'item',
                url: '/contact',
                icon: PhoneIcon,
                breadcrumbs: true
            },
        ],
        // ADVISER (Danışman Hekim) — dashboardlinks/adviser.html menüsü BİREBİR:
        // Takip Paneli, Vakalarım(14), Supervisor Follow, Gallery(chief), Yorum Yaptığım Vakalar,
        // K.K Analiz, Analizler K.K.(6542), Uzayan Vakalar(6542), Bildirimler.
        ortheroadviser: [
            {
                id: 'main-panel-adviser',
                title: <FormattedMessage id="Takip Paneli" />,
                type: 'item',
                url: '/main-panel-adviser',
                icon: LocationOnIcon,
                breadcrumbs: false
            },
            // Vakalarım — MVC dashboardlinks/adviser.html L70-85 birebir: iç içe drawer
            {
                id: 'adviser-cases-group',
                title: <FormattedMessage id="Vakalarım" />,
                type: 'collapse',
                icon: VisibilityIcon,
                children: [
                    {
                        id: 'adviser-cases',
                        title: <FormattedMessage id="Danışman Görüşü" />,
                        type: 'item',
                        url: '/adviser-cases',
                        icon: VisibilityIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'adviser-commented-cases',
                        title: <FormattedMessage id="Yorum Yaptığım Vakalar" />,
                        type: 'item',
                        url: '/adviser-commented-cases',
                        icon: VisibilityIcon,
                        breadcrumbs: false
                    },
                    // Yalnız pk 6542 (MVC L79-82): iç içe kalır
                    ...(userData?.is_quality_control_adviser === true ? [
                        {
                            id: 'adviser-analysis-quality-control',
                            title: <FormattedMessage id="Analizler Kalite Kontrol" />,
                            type: 'item',
                            url: '/adviser-analysis-quality-control',
                            icon: VisibilityIcon,
                            breadcrumbs: false
                        },
                        {
                            id: 'adviser-exceeding-limits',
                            title: <FormattedMessage id="Uzayan Vakalar" />,
                            type: 'item',
                            url: '/adviser-exceeding-limits',
                            icon: VisibilityIcon,
                            breadcrumbs: false
                        }
                    ] : []),
                ]
            },
            {
                id: 'adviser-supervisor-follow-list',
                title: <FormattedMessage id="Supervisor Follow" />,
                type: 'item',
                url: '/adviser-supervisor-follow-list',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            // Chief danışmana: Orthero Gallery (dashboardlinks/adviser.html L61-68)
            ...(userData?.is_chief === true ? [{
                id: 'adviser-gallery',
                title: <FormattedMessage id="Orthero Gallery Vakaları" />,
                type: 'item',
                url: '/adviser-gallery',
                icon: CollectionsBookmarkIcon,
                breadcrumbs: false
            }] : []),
            {
                id: 'adviser-quality-control-analysis',
                title: <FormattedMessage id="K.K Analiz" />,
                type: 'item',
                url: '/adviser-quality-control-analysis',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'adviser-notifications',
                title: <FormattedMessage id="Bildirimler" />,
                type: 'item',
                url: '/adviser-notifications',
                icon: EmailIcon,
                breadcrumbs: false
            },
        ],

        ortheroanatec: [
            {
                id: 'main-panel-anatec',
                title: <FormattedMessage id="Main panel" />,
                type: 'item',
                url: '/main-panel-anatec',
                icon: LocationOnIcon,
                breadcrumbs: false
            },
            {
                id: 'search-anatec',
                title: <CustomSearchItem />,
                type: 'search',
                noStyle: true,
                breadcrumbs: false
            },
            {
                id: 'anatec-calendar',
                title: <FormattedMessage id="Anatec Calendar" />,
                type: 'item',
                url: '/anatec-calendar',
                icon: DateRangeIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-calendar-new',
                title: <FormattedMessage id="Analiz Takvimi Yeni" />,
                type: 'item',
                url: '/anatec-calendar-new',
                icon: DateRangeIcon,
                breadcrumbs: false
            },
            {
                id: 'case-calendar',
                title: <FormattedMessage id="Vaka Takvimi" />,
                type: 'item',
                url: '/case-calendar',
                icon: AssignmentIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-myunsuitability',
                title: <FormattedMessage id="My Unsuitability" />,
                type: 'item',
                url: '/anatec-myunsuitability',
                icon: ReportIcon,
                breadcrumbs: false
            },

            {
                id: 'anatec-cases',
                title: <FormattedMessage id="My Cases" />,
                type: 'item',
                url: '/anatec-cases',
                icon: GroupIcon,
                breadcrumbs: false
            },

            {
                id: 'anatec-quality-control-analysis',
                title: <FormattedMessage id="Analysis Quality Control" />,
                type: 'item',
                url: '/anatec-quality-control-analysis',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-trend',
                title: <FormattedMessage id="Anatec Trend" />,
                type: 'item',
                url: '/anatec-trend',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysisrate-statistic",
                title: <FormattedMessage id="Analiz Excel İstatistikler" />,
                type: "item",
                url: "/anatec-analysisrate-statistic",
                icon: GridOnIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysis-feedback-list",
                title: <FormattedMessage id="Analiz Geri Bildirimleri" />,
                type: "item",
                url: "/anatec-analysis-feedback-list",
                icon: StarIcon,
                breadcrumbs: false
            },

        ],

        ortheroanatecadmin: [
            {
                id: 'main-panel-anatec',
                title: <FormattedMessage id="Main panel" />,
                type: 'item',
                url: '/main-panel-anatec',
                icon: LocationOnIcon,
                breadcrumbs: false
            },
            {
                id: 'search-anatec',
                title: <CustomSearchItem />,
                type: 'search',
                noStyle: true,
                breadcrumbs: false
            },
            {
                id: 'anatec-calendar',
                title: <FormattedMessage id="Anatec Calendar" />,
                type: 'item',
                url: '/anatec-calendar',
                icon: DateRangeIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-calendar-new',
                title: <FormattedMessage id="Analiz Takvimi Yeni" />,
                type: 'item',
                url: '/anatec-calendar-new',
                icon: DateRangeIcon,
                breadcrumbs: false
            },
            {
                id: 'case-calendar',
                title: <FormattedMessage id="Vaka Takvimi" />,
                type: 'item',
                url: '/case-calendar',
                icon: AssignmentIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-myunsuitability',
                title: <FormattedMessage id="My Unsuitability" />,
                type: 'item',
                url: '/anatec-myunsuitability',
                icon: ReportIcon,
                breadcrumbs: false
            },

            {
                id: 'anatec-cases',
                title: <FormattedMessage id="My Cases" />,
                type: 'item',
                url: '/anatec-cases',
                icon: GroupIcon,
                breadcrumbs: false
            },
            {
                id: 'urgent-requests',
                title: <FormattedMessage id="Acil Talepler" defaultMessage={"Acil Talepler"}/>,
                type: 'item',
                url: '/urgent-requests',
                icon: PriorityHighIcon,
                breadcrumbs: false
            },
            // {
            //     id: 'anatec-general-statistic',
            //     title: <FormattedMessage id="General Statistics" />,
            //     type: 'item',
            //     url: '/anatec-general-statistic',
            //     icon: BarChartIcon,
            //     breadcrumbs: false
            // },
            {
                id: "anatec-analysisrate-statistic",
                title: <FormattedMessage id="Analiz Excel İstatistikler" />,
                type: "item",
                url: "/anatec-analysisrate-statistic",
                icon: GridOnIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysis-feedback-list",
                title: <FormattedMessage id="Analiz Geri Bildirimleri" />,
                type: "item",
                url: "/anatec-analysis-feedback-list",
                icon: StarIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysiscorrection-statistic",
                title: <FormattedMessage id="Analiz Düzeltme Listesi" />,
                type: "item",
                url: "/anatec-analysiscorrection-statistic",
                icon: GridOnIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysisconfirmationfollow-statistic",
                title: <FormattedMessage id="Analiz Onay Excel İstatistikler" />,
                type: "item",
                url: "/anatec-analysisconfirmationfollow-statistic",
                icon: GridOnIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysissoftfollow-statistic",
                title: <FormattedMessage id="SoftSmile Follow" />,
                type: "item",
                url: "/anatec-analysissoftfollow-statistic",
                icon: GridOnIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysisproductionimpressions-statistic",
                title: <FormattedMessage id="Üretim Raporu Analiz Ölçü" />,
                type: "item",
                url: "/anatec-analysisproductionimpressions-statistic",
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysisdoctormatrix-statistic",
                title: <FormattedMessage id="Doctor Matrix" />,
                type: "item",
                url: "/anatec-analysisdoctormatrix-statistic",
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-quality-control-analysis',
                title: <FormattedMessage id="Analysis Quality Control" />,
                type: 'item',
                url: '/anatec-quality-control-analysis',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-trend-admin',
                title: <FormattedMessage id="Anatec Trend List" />,
                type: 'item',
                url: '/anatec-trend-admin',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-modtec-trend',
                title: "K.K. Tarama",
                type: 'item',
                url: '/anatec-modtec-trend',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-supervisor-follow-list',
                title: <FormattedMessage id="Supervisor Takip Listesi" defaultMessage={"Supervisor Takip Listesi"}/>,
                type: 'item',
                url: '/anatec-supervisor-follow-list',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-cancel-request-list',
                title: "İptal İsteği Listesi",
                type: 'item',
                url: '/anatec-cancel-request-list',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-active-request-list',
                title: "Aktif İsteği Listesi",
                type: 'item',
                url: '/anatec-active-request-list',
                icon: BarChartIcon,
                breadcrumbs: false
            },
        ],
        ortheroanatecsecondadmin: [
            {
                id: 'main-panel-anatec',
                title: <FormattedMessage id="Main panel" />,
                type: 'item',
                url: '/main-panel-anatec',
                icon: LocationOnIcon,
                breadcrumbs: false
            },
            {
                id: 'search-anatec',
                title: <CustomSearchItem />,
                type: 'search',
                noStyle: true,
                breadcrumbs: false
            },
            {
                id: 'anatec-calendar',
                title: <FormattedMessage id="Anatec Calendar" />,
                type: 'item',
                url: '/anatec-calendar',
                icon: DateRangeIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-calendar-new',
                title: <FormattedMessage id="Analiz Takvimi Yeni" />,
                type: 'item',
                url: '/anatec-calendar-new',
                icon: DateRangeIcon,
                breadcrumbs: false
            },
            {
                id: 'case-calendar',
                title: <FormattedMessage id="Vaka Takvimi" />,
                type: 'item',
                url: '/case-calendar',
                icon: AssignmentIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-myunsuitability',
                title: <FormattedMessage id="My Unsuitability" />,
                type: 'item',
                url: '/anatec-myunsuitability',
                icon: ReportIcon,
                breadcrumbs: false
            },

            {
                id: 'anatec-cases',
                title: <FormattedMessage id="My Cases" />,
                type: 'item',
                url: '/anatec-cases',
                icon: GroupIcon,
                breadcrumbs: false
            },

            // {
            //     id: 'anatec-quality-control-analysis',
            //     title: <FormattedMessage id="Analysis Quality Control" />,
            //     type: 'item',
            //     url: '/anatec-quality-control-analysis',
            //     icon: BarChartIcon,
            //     breadcrumbs: false
            // },
            {
                id: 'anatec-trend',
                title: <FormattedMessage id="Anatec Trend" />,
                type: 'item',
                url: '/anatec-trend',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-analysisconfirmationfollow-statistic',
                title: <FormattedMessage id="Anatec Analysis Confirmation Follow" />,
                type: 'item',
                url: '/anatec-analysisconfirmationfollow-statistic',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            ,
            {
                id: "anatec-analysiscorrection-statistic",
                title: <FormattedMessage id="Analiz Düzeltme Listesi" />,
                type: "item",
                url: "/anatec-analysiscorrection-statistic",
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: "anatec-analysis-feedback-list",
                title: <FormattedMessage id="Analiz Geri Bildirimleri" />,
                type: "item",
                url: "/anatec-analysis-feedback-list",
                icon: StarIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-quality-control-analysis',
                title: <FormattedMessage id="Analysis Quality Control" />,
                type: 'item',
                url: '/anatec-personal-quality-control-analysis',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-supervisor-follow-list',
                title: <FormattedMessage id="Supervisor Takip Listesi" defaultMessage={"Supervisor Takip Listesi"}/>,
                type: 'item',
                url: '/anatec-supervisor-follow-list',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-cancel-request-list',
                title: "İptal İsteği Listesi",
                type: 'item',
                url: '/anatec-cancel-request-list',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-active-request-list',
                title: "Aktif İsteği Listesi",
                type: 'item',
                url: '/anatec-active-request-list',
                icon: BarChartIcon,
                breadcrumbs: false
            },

        ],
        ortheroanatecoutsource: [
            {
                id: 'main-panel-anatec',
                title: <FormattedMessage id="Main panel" />,
                type: 'item',
                url: '/main-panel-anatec',
                icon: LocationOnIcon,
                breadcrumbs: false
            },
            {
                id: 'search-anatec',
                title: <CustomSearchItem />,
                type: 'search',
                noStyle: true,
                breadcrumbs: false
            },
            // {
            //     id: 'anatec-calendar',
            //     title: <FormattedMessage id="Anatec Calendar" />,
            //     type: 'item',
            //     url: '/anatec-calendar',
            //     icon: DateRangeIcon,
            //     breadcrumbs: false
            // },


            {
                id: 'anatec-cases',
                title: <FormattedMessage id="My Cases" />,
                type: 'item',
                url: '/anatec-cases',
                icon: GroupIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-trend',
                title: <FormattedMessage id="Anatec Trend" />,
                type: 'item',
                url: '/anatec-trend',
                icon: BarChartIcon,
                breadcrumbs: false
            }
            ,
            {
                id: 'anatec-quality-control-analysis',
                title: <FormattedMessage id="Analysis Quality Control" />,
                type: 'item',
                url: '/anatec-personal-quality-control-analysis',
                icon: BarChartIcon,
                breadcrumbs: false
            },


        ],
        ortheroanateconyx: [
            {
                id: 'main-panel-anatec',
                title: <FormattedMessage id="Main panel" />,
                type: 'item',
                url: '/main-panel-anatec',
                icon: LocationOnIcon,
                breadcrumbs: false
            },
            {
                id: 'search-anatec',
                title: <CustomSearchItem />,
                type: 'search',
                noStyle: true,
                breadcrumbs: false
            },
            // {
            //     id: 'anatec-calendar',
            //     title: <FormattedMessage id="Anatec Calendar" />,
            //     type: 'item',
            //     url: '/anatec-calendar',
            //     icon: DateRangeIcon,
            //     breadcrumbs: false
            // },


            {
                id: 'anatec-cases',
                title: <FormattedMessage id="My Cases" />,
                type: 'item',
                url: '/anatec-cases',
                icon: GroupIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-trend',
                title: <FormattedMessage id="Anatec Trend" />,
                type: 'item',
                url: '/anatec-trend',
                icon: BarChartIcon,
                breadcrumbs: false
            },
            {
                id: 'anatec-quality-control-analysis',
                title: <FormattedMessage id="Analysis Quality Control" />,
                type: 'item',
                url: '/anatec-personal-quality-control-analysis',
                icon: BarChartIcon,
                breadcrumbs: false
            },


        ],

    };

    return {
        id: 'sample-docs-roadmap',
        type: 'group',
        children: roleBasedItems[role] || []
    };
};

export default getSidebarItems;
